import mock from "src/utils/mock";

const serviceStatus = {
  operational: false,
  message: "Status update message"
};

mock.onGet("/api/serviceStatus").reply(200, { serviceStatus });
